import { render, staticRenderFns } from "./ManageDewormingList.vue?vue&type=template&id=4965e365&scoped=true&"
import script from "./ManageDewormingList.vue?vue&type=script&lang=js&"
export * from "./ManageDewormingList.vue?vue&type=script&lang=js&"
import style0 from "./ManageDewormingList.vue?vue&type=style&index=0&id=4965e365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965e365",
  null
  
)

export default component.exports